export class ErrorWithFingerprint extends Error {
  dd_fingerprint?: string;
}

export function datadogFingerprint(errorMessage: string) {
  if (
    errorMessage.startsWith("No data returned for operation") &&
    errorMessage.includes("TypeError: Failed to fetch")
  ) {
    return "no-data-returned-failed-to-fetch";
  }

  return null;
}
